import React, { FunctionComponent, useState } from 'react'
import styles from './auth.module.scss'
import Title from '@/components/_custom/Title/title'
import UserInput from '@/components/_custom/UserInput/userInput'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import validator from 'validator'
import { useTranslation } from 'react-i18next'

interface WelcomeProps {
    email: string
    setEmail: (email: string) => void
    searchMail: () => void
    logo?: string
}

const Welcome: FunctionComponent<WelcomeProps> = ({ searchMail, email, setEmail, logo }: WelcomeProps) => {
    const { t } = useTranslation()

    const [emailValid, setEmailValid] = useState<boolean>(validator.isEmail(email) && email !== '')

    function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>): void {
        if (e.key === 'Enter' && emailValid) searchMail()
    }

    return (
        <div className={styles.Form}>
            <div className={styles.Title}>
                <Title text={t('welcome')} />
            </div>
            <div className={styles.Input}>
                <UserInput
                    id='email'
                    label={t('email')}
                    type='text'
                    verify={'email'}
                    unallowedCharacters={'email'}
                    required
                    fullWidth
                    value={email}
                    setValue={setEmail}
                    setValid={setEmailValid}
                    onKeyPress={handleKeyPress}
                />
            </div>
            <ButtonText text={t('continue')} onClick={searchMail} fullWidth disabled={!emailValid} />
            {logo && <img src={`data:image/png;base64,${logo}`} alt={'logo'} className={styles.Logo} />}
        </div>
    )
}

export default Welcome
